<template>
    <div>
        <h3 class="font-weight-regular submenu-title">{{ characteristic.description }}</h3>
        <v-radio-group v-model="radioGroupValue" row :persistent-hint="doorConfigurationProp !== modelSelection" :hint="$t('hinweisEN179EN1125')">
            <template v-if="characteristic.values.length > 10">
                <v-row>
                    <template v-if="characteristic.code === 'KTU_MM_ARTIKELNR'">
                        <v-col sm="12" md="6">
                            <v-autocomplete dense outlined return-object :menu-props="{offsetY: true}"
                                class="mt-n5"
                                hide-details
                                :items="characteristic.values"
                                item-text="description"
                                item-value="value"
                                :value="getRegisteredCharacteristicsValue('KTU_MM_ARTIKELNR', doorConfigurationProp).value"
                                @change="addCharacterisitc(characteristic, $event); filterMatrix(characteristic, $event.id)"
                            ></v-autocomplete>
                        </v-col>
                    </template>
                    <template v-else>
                        <v-col cols="12" class="py-2" v-for="(valueDefinition, index) in characteristic.values" :key="index">
                            <v-radio
                                    class="menu-description"
                                :label="valueDefinition.description"
                                :value="valueDefinition.value"
                                @change="addCharacterisitc(characteristic, valueDefinition); doorConfigurationProp == modelSelection ? filterMatrix(characteristic, valueDefinition.id) : null"
                            ></v-radio>
                            <v-checkbox class="ma-0 pa-0 mt-3"
                                        :disabled="!isFluchtChecked()"
                                        v-if="characteristic.code === 'KTU_MM_FLUCHT'"
                                        :input-value="getRegisteredCharacteristicsValue('KTU_MM_FLUCHT_SONDER', modelSelection).value.value === 'JA'"
                                        :label="$t('fluchtSonderLabel')"
                                        @change="checkBoxAddCharacteristic('KTU_MM_FLUCHT_SONDER')"></v-checkbox>
                        </v-col>
                    </template>
                </v-row>
            </template>
            <template v-else>
                <template v-if="characteristic.code === 'KTU_MM_ARTIKELNR'">
                    <v-row>
                        <v-col sm="12" md="6">
                            <v-autocomplete dense outlined return-object :menu-props="{offsetY: true}"
                                class="mt-n4"
                                hide-details
                                :items="characteristic.values"
                                item-text="description"
                                item-value="value"
                                :value="getRegisteredCharacteristicsValue('KTU_MM_ARTIKELNR', doorConfigurationProp).value"
                                @change="addCharacterisitc(characteristic, $event); filterMatrix(characteristic, $event.id)"
                            ></v-autocomplete>
                        </v-col>
                    </v-row>
                </template>
                <template v-else>
                    <v-radio
                        class="col-12 pa-0 my-2 menu-description"
                        v-for="(valueDefinition, index) in characteristic.values"
                        :key="index"
                        :label="valueDefinition.description"
                        :value="valueDefinition.value"
                        @change="addCharacterisitc(characteristic, valueDefinition); doorConfigurationProp == modelSelection ? filterMatrix(characteristic, valueDefinition.id) : null"
                    ></v-radio>
                    <v-checkbox class="ma-0 pa-0 mt-3"
                                :disabled="!isFluchtChecked()"
                                v-if="characteristic.code === 'KTU_MM_FLUCHT'"
                                :input-value="getRegisteredCharacteristicsValue('KTU_MM_FLUCHT_SONDER', modelSelection).value.value === 'JA'"
                                :label="$t('fluchtSonderLabel')"
                                @change="checkBoxAddCharacteristic('KTU_MM_FLUCHT_SONDER')"></v-checkbox>
                </template>      
            </template>
        </v-radio-group>
        <!-- <label v-for="(valueDefinition, index) in characteristic.values" :key="index" 
        @click="addCharacterisitc(characteristic, valueDefinition);filterMatrix(characteristic.id, valueDefinition.id)" 
        :class="{ 'btn':true, 'btn-secondary':true, 'active': valueCheckState(characteristic.code, valueDefinition.value) }">
            <div class="radio-btn">
                <span></span>
            </div>
            <input type="radio" :name="valueDefinition.description" autocomplete="off"> {{ valueDefinition.description }}
        </label> -->
    </div>
</template>
<script>
    import Vue from 'vue';  
    import { Characteristic, ValueDefinition, FilterMatrixItem } from '../../../configurator/types'; 
    import { FilterMatrix } from '../../../configurator/FilterMatrix'; 
    import { DoorConfiguration } from '../../../configurator/DoorConfiguration';
    import { modelSelectionNavigationItems, NavigationFilter } from '../../../configurator/ModelSelectionNavigationItems';   
    import { mapGetters } from 'vuex';
    import { mapActions } from 'vuex';

    
    export default Vue.extend({
        name: 'MSRadio',
        data() {
            return {
                active: null,
                radioGroupValue: null,
                modelSelection: DoorConfiguration.ModelSelection
            }
        },
        props: {
            characteristic : Object,
            doorConfigurationProp : Number
        },
        computed: {            
            ...mapGetters('configuratorModule', ['getCurrentDoorConfiguration', 'getFilteredCharacteristics', 'getRegisteredCharacteristicsValue']),
            ...mapGetters('modelSelectionModule', [ 'getNavigationItems', 'getMatrixCharacteristics', 'getHasClickedNextStep', 'getCharacteristic' ]),
        },
        methods: {
            ...mapActions('configuratorModule', ['updateDoorConfiguration', 'setFilteredCharacteristics']),
            ...mapActions('modelSelectionModule', ['checkBoxAddCharacteristic', 'extraFilterCharacteristic']),

            isFluchtChecked() {
              return this.getRegisteredCharacteristicsValue('KTU_MM_FLUCHT', this.modelSelection).value.value === 'JA';
            },
            isSonderFluchtChecked() {
                return this.getRegisteredCharacteristicsValue('KTU_MM_FLUCHT_SONDER', this.modelSelection).value.value === 'JA';
            },
            addCharacterisitc(characteristic, valueDefinition) {
                    const val = {
                        id: valueDefinition.id,
                        description: valueDefinition.description,
                        value: valueDefinition.value,
                        resource: '',
                        default: 0,
                    };

                    const selectedCharacteristic = {
                        id: characteristic.id,
                        description: characteristic.description,
                        code: characteristic.code,
                        value: val             
                    };
                    
                    this.doorConfiguration = this.getCurrentDoorConfiguration;
                    this.doorConfiguration.Add(this.doorConfigurationProp, selectedCharacteristic);          
                    this.$store.dispatch('configuratorModule/updateDoorConfiguration', this.doorConfiguration);
                    if(this.doorConfigurationProp == DoorConfiguration.ModelSelection)
                        this.updateNavigation();
            },
            filterMatrix(characteristic, valueDefinitionId) {
                const filterMatrixItem = {
                    characteristicId: characteristic.id,
                    valueDefinitionId: valueDefinitionId,                    
                };
                const fluchtSonder = this.getRegisteredCharacteristicsValue("KTU_MM_FLUCHT_SONDER", this.doorConfigurationProp)
                let matrixFilter = new FilterMatrix(this.getFilteredCharacteristics.selectedCharacteristics);
                const filteredCharacteristics = matrixFilter.AddFilter(filterMatrixItem);                
                const selectedCharacteristicValues = matrixFilter.StringResult(this.getFilteredCharacteristics.selectedCharacteristics);

                 const filteredCharacteristicsObject = {
                    selectedCharacteristicValues: selectedCharacteristicValues,
                    selectedCharacteristics: filteredCharacteristics,
                };

                this.$store.dispatch('configuratorModule/setFilteredCharacteristics', filteredCharacteristicsObject);

                NProgress.start();
                this.$EventBus.$emit('disableEnableNextBtn', true)
                this.axios.get("api/modelselection/getModelMatrix?selectedValues="+this.getFilteredCharacteristics.selectedCharacteristicValues).then(response => {
                     NProgress.done();
                    this.$EventBus.$emit('disableEnableNextBtn', false)
                     this.$store.dispatch('modelSelectionModule/filterProductMatrix',{data: response.data, characteristic: characteristic});
                     if (response.data.characteristics.length > 0) {
                        this.addSingleCharacteristicsFilered(characteristic, valueDefinitionId);

                         // Add old value of flucht sonder after clear data
                         if (fluchtSonder.id !== 0 && characteristic.code !== 'KTU_MM_FLUCHT'){
                            const selectedCharacteristic = {
                                id: fluchtSonder.id,
                                description: fluchtSonder.description,
                                code: fluchtSonder.code,
                                value: fluchtSonder.value
                            };
                            this.doorConfiguration.Add(this.doorConfigurationProp, selectedCharacteristic);
                            this.$store.dispatch('configuratorModule/updateDoorConfiguration', this.doorConfiguration);
                        }
                     }else {
                        const filteredCharacteristicsObject = {
                            selectedCharacteristicValues: '',
                            selectedCharacteristics: new Array(),
                        };

                        this.$store.dispatch('configuratorModule/setFilteredCharacteristics', filteredCharacteristicsObject);
                        this.doorConfiguration = this.getCurrentDoorConfiguration;         
                        this.doorConfiguration.ClearConfiguration(this.doorConfigurationProp);

                         if (fluchtSonder.id !== 0 && characteristic.code !== 'KTU_MM_FLUCHT'){
                             // Add old value of flucht sonder after clear data
                             const selectedCharacteristic = {
                                 id: fluchtSonder.id,
                                 description: fluchtSonder.description,
                                 code: fluchtSonder.code,
                                 value: fluchtSonder.value
                             };
                             this.doorConfiguration.Add(this.doorConfigurationProp, selectedCharacteristic);
                         }

                        this.$store.dispatch('configuratorModule/updateDoorConfiguration', this.doorConfiguration);
                    }

                    if(characteristic.code === 'KTU_MM_OEFFNUNGSART') {
                        this.filterTopPanel();
                    }
                    else if(characteristic.code === 'KTU_MM_FLUCHT') {
                        if(!this.isFluchtChecked() && this.isSonderFluchtChecked()) {
                            this.checkBoxAddCharacteristic('KTU_MM_FLUCHT_SONDER');
                        }
                    }

                    let initSonderFlucht = this.getRegisteredCharacteristicsValue('KTU_MM_FLUCHT_SONDER', this.modelSelection).value.value;
                    if(initSonderFlucht === '0') {
                        this.checkBoxAddCharacteristic('KTU_MM_FLUCHT_SONDER');
                        if(this.isSonderFluchtChecked()) {
                            this.checkBoxAddCharacteristic('KTU_MM_FLUCHT_SONDER');
                        }
                    }

                    this.extraDependencies();
                });
            },
            extraDependencies() {
                this.filterSoundProof();
            },
            filterSoundProof() {
                let fireProtection = this.getRegisteredCharacteristicsValue('KTU_MM_FUNKTION_BH', this.modelSelection).value.value;
                let resistanceClass = this.getRegisteredCharacteristicsValue('KTU_MM_FUNKTION_RC', this.modelSelection).value.value;

                if(fireProtection === '30' && resistanceClass === '4') {
                    this.extraFilterCharacteristic({'key': 'KTU_MM_FUNKTION_S', data: ["32"]});
                }

            },
            addSingleCharacteristicsFilered(filteredChar, filteredValueDefinitionId) {
                this.doorConfiguration = this.getCurrentDoorConfiguration;
                this.doorConfiguration.ClearConfiguration(this.doorConfigurationProp)

                this.getMatrixCharacteristics.forEach((char) => {
                    if(char.values.length == 1) {

                        const val = {
                            id: char.values[0].id,
                            description: char.values[0].description,
                            value: char.values[0].value,
                            resource: '',
                            default: 0,
                        };

                        const selectedCharacteristic = {
                            id: char.id,
                            description: char.description,
                            code: char.code,
                            value: val             
                        };

                        this.doorConfiguration.Add(this.doorConfigurationProp, selectedCharacteristic);
                        this.$store.dispatch('configuratorModule/updateDoorConfiguration', this.doorConfiguration); 
                        this.updateNavigation();
                    }
                    else if (filteredChar.code === char.code){
                        // add filtered value
                        let findValue = filteredChar.values.find(f => f.id === filteredValueDefinitionId)

                        if (findValue !== undefined){
                            const filteredVal = {
                                id: findValue.id,
                                description: findValue.description,
                                value: findValue.value,
                                resource: '',
                                default: 0,
                            };

                            const filteredSelectedCharacteristic = {
                                id: char.id,
                                description: char.description,
                                code: char.code,
                                value: filteredVal
                            };

                            this.doorConfiguration.Add(this.doorConfigurationProp, filteredSelectedCharacteristic);
                            this.$store.dispatch('configuratorModule/updateDoorConfiguration', this.doorConfiguration);
                            this.updateNavigation();
                        }
                    }
                });
            },
            filterTopPanel() {
                let getTopPanelValues = this.getCharacteristic('KTU_MM_KOMBI_ST_OL');
                let getTopPanel = this.getRegisteredCharacteristicsValue('KTU_MM_KOMBI_ST_OL', this.modelSelection).value.value;
                let getWingDoor = this.getRegisteredCharacteristicsValue('KTU_MM_OEFFNUNGSART', this.modelSelection).value.value;
                if(getWingDoor === 'D1') {
                    if(getTopPanel === 'D2-A') {
                        let valueToSet = getTopPanelValues.values.find(x => x.value === 'D1-A');
                        this.addCharacterisitc(getTopPanelValues, valueToSet);
                        this.filterMatrix(getTopPanelValues, valueToSet.id)
                    }
                    else if (getTopPanel === 'D2-A-O'){
                        let valueToSet = getTopPanelValues.values.find(x => x.value === 'D1-A-O');
                        this.addCharacterisitc(getTopPanelValues, valueToSet);
                        this.filterMatrix(getTopPanelValues, valueToSet.id)
                    }
                }
                else if(getWingDoor === 'D2') {
                    if(getTopPanel === 'D1-A') {
                        let valueToSet = getTopPanelValues.values.find(x => x.value === 'D2-A');
                        this.addCharacterisitc(getTopPanelValues, valueToSet);
                        this.filterMatrix(getTopPanelValues, valueToSet.id)
                    }
                    else if (getTopPanel === 'D1-A-O'){
                        let valueToSet = getTopPanelValues.values.find(x => x.value === 'D2-A-O');
                        this.addCharacterisitc(getTopPanelValues, valueToSet);
                        this.filterMatrix(getTopPanelValues, valueToSet.id)
                    }
                }
            },
            valueCheckState(characteristicCode, value) {
                //to be removed
                const modelSelectionValues = this.getCurrentDoorConfiguration.Get(this.doorConfigurationProp)
                const filteredCharacteristic = modelSelectionValues.filter((item) => item.code === characteristicCode && item.value.value === value)[0];

                if(filteredCharacteristic != null || typeof filteredCharacteristic != 'undefined') {
                    return true;
                }
                return false;
            },
            valueCheckStateModified(index,characteristicCode, value) {     
                const modelSelectionValues = this.getCurrentDoorConfiguration.Get(this.doorConfigurationProp)
                const filteredCharacteristic = modelSelectionValues.filter((item) => item.code === characteristicCode && item.value.value === value)[0];
                if(filteredCharacteristic != null || typeof filteredCharacteristic != 'undefined') {
                    this.active = index;
                }
            },
            updateNavigation() {
                // depending on this for navigation status
                let nav = new NavigationFilter(this.getNavigationItems)
                this.doorConfiguration = this.getCurrentDoorConfiguration;
                const filter = nav.NavigationItemsFilter(this.doorConfiguration.Get(this.doorConfigurationProp))
                this.$store.dispatch('modelSelectionModule/setNavigationItems', filter);
                this.setMandatoryWarnings();
            },
            setMandatoryWarnings() {
                if(this.getHasClickedNextStep !== false) {
                    for(let i = 0; i< this.getNavigationItems.length; i++){
                        if(this.getNavigationItems[i].success === false && this.getNavigationItems[i].warning === false) {
                            this.getNavigationItems[i].warning = true;
                        }
                    }
                }

            }
        },
        beforeMount() {
            // When it called from function the default value has not to be set
            // if(this.doorConfigurationProp !== this.modelSelection){
            //     this.radioGroupValue = null;
            //     return
            // }

            if(this.characteristic.values.length === 1 && this.characteristic.values.length > 1) {
                this.radioGroupValue = this.characteristic.values[0].value
            } else {
                const modelSelectionValues = this.getCurrentDoorConfiguration.Get(this.doorConfigurationProp)
                const selectedCharacteristic = modelSelectionValues.find(model => { 
                    return model.code == this.characteristic.code && this.characteristic.values.find(value => model.value.value == value.value)
                })
                if(typeof selectedCharacteristic !== 'undefined') {
                    this.radioGroupValue = selectedCharacteristic.value.value
                }
            }
        },
        mounted() {
            this.$EventBus.$on('updateNavigationEmited', (valuePassed) => {
                this.updateNavigation();
            });
        },
    });
</script>

<style lang="scss">
    //label.v-label{
    //    margin-bottom: 0px;
    //    margin-left: 5px;
    //}
</style>